import { Injectable } from '@angular/core'
import { CareType } from 'src/app/models/care-type.model'
import { CodeListService } from './CodeListService'

@Injectable({
  providedIn: 'root',
})
export class CareTypeService extends CodeListService<CareType> {
  recordClass = CareType

  constructor() {
    super()
  }
}
